import React from "react";

import { specialty } from "../data";

import SpecialtySlider from "./SpecialtySlider";

const Specialty = () => {
  const { title, subtitle, link, icon } = specialty;
  return (
    <section className="section">
      <div className="container mx-auto">
        <div className="flex flex-col lg:flex-row lg:gap-x-6">
          <div className="flex md:flex-col items-baseline gap-x-6 mb-6 lg:mb-0 ">
            <h2 className="title max-w-[245px] lg:mt-[30px] lg:mb-[90px]">
              {title}
            </h2>
            <p className="max-w-[245px] lg:mb-12">{subtitle}</p>
            <div className="hidden lg:flex items-center">
              <div className="hover:border-b border-primary lg:items-center font-medium transition-all">
                {link}
              </div>
              <div className="text-3xl">{icon}</div>
            </div>
          </div>
          <div className="lg:max-w-[800px] xl:max-w-[990px] lg:-right-28">
            <SpecialtySlider />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Specialty;
